import React, { useState, useEffect } from "react"
import { Popover, PopoverHeader, PopoverBody, Button, Input, FormGroup, Label } from "reactstrap"
import gql from "graphql-tag"
import withApolloClient from "../../withApolloClient"

const UpdateBoardColumnMutation = gql`
    mutation UpdateBoardColumnMutation($input: UpdateBoardColumnMutationInput!) {
        updateBoardColumn(input: $input) {
            ok
            errors {
                field
                messages
            }
        }
    }
`

const RenameColumnPopOver = ({ isOpen, toggle, target, column, apolloClient, refetchBoardQuery }) => {
    const [newTitle, setNewTitle] = useState("")
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    useEffect(() => {
        if (isOpen) {
            setNewTitle(column?.title || "")
        }
    }, [isOpen, column?.columnNode?.id])

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!newTitle.trim()) return
        if (!apolloClient) return setError("GQL Client not found")
        if (!column?.columnNode?.id) return setError("Column ID not found")

        setLoading(true)
        setError("")

        try {
            const { data } = await apolloClient.mutate({
                mutation: UpdateBoardColumnMutation,
                variables: { input: { columnId: column?.columnNode?.id, title: newTitle.trim() } },
            })

            if (!data?.updateBoardColumn?.ok) {
                throw new Error(
                    data?.updateBoardColumn?.errors?.[0]?.messages?.[0] || "Column rename failed"
                )
            }

            toggle() // Close popover
            if (refetchBoardQuery) await refetchBoardQuery()

        } catch (err) {
            setError(err.message || "Error renaming column")
        } finally {
            setLoading(false)
        }
    }

    return (
        <Popover placement="right" trigger="legacy" className="task-header-menu-popover" isOpen={isOpen} target={target} toggle={toggle}>
            <PopoverHeader>Rename Column</PopoverHeader>
            <PopoverBody>
                <form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label for="renameColumnInput">Column Name</Label>
                        <Input
                            id="renameColumnInput"
                            type="text"
                            placeholder="Enter new column name"
                            value={newTitle}
                            onChange={(e) => setNewTitle(e.target.value)}
                            autoFocus
                        />
                        {error && <div className="text-danger mt-1">{error}</div>}
                    </FormGroup>
                    <div className="d-flex justify-content-end">
                        <Button color="primary" size="sm" type="submit" disabled={loading}>
                            {loading ? "Saving..." : "Save"}
                        </Button>
                    </div>
                </form>
            </PopoverBody>
        </Popover>
    )
}

export default withApolloClient(RenameColumnPopOver)
